// extracted by mini-css-extract-plugin
export default {"titulo":"style_titulo__Vyx7-","playlistITemTitle":"style_playlistITemTitle__B1C1V"};